module.exports = __webpack_public_path__ + "img/home_map_Vietnam_blue.d9d63e79.png";